import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.cryptoDetails';
const LABELS = makeLabels(
  {
    TITLE: ['title', 'Crypto Details'],
    CRYPTOCURRENCY: ['cryptocurrency', 'Cryptocurrency'],
    NETWORK: ['network', 'Network'],
    WALLET_ADDRESS: ['walletAddress', 'Wallet Address'],
    WALLET_MEMO: ['walletMemo', 'Wallet Memo'],
    TRANSACTION_HASH: ['transactionHash', 'Transaction Hash'],
  },
  NAMESPACE,
);

export default LABELS;
